import React, { useState, useEffect } from "react"
import { toast } from 'react-toastify'
import Loading from "../../components/Loading"

import DropDown from "../DropDown"
import PreJoinModal from "../exam/PreJoinModal"
import GroupFolderItem from "./../GroupFolderItem"

import Folder from './../../images/icons/folder.png'
import Exam from './../../images/icons/exam.png'
import Back from './../../images/icons/arrow-bg.png'

import { apiCall, validateToken } from './../../../Helper'
import { Link } from "gatsby"

export default () => {
  const [isLoading, setIsLoading] = useState(true)
  // const [showCantJoin, setShowCantJoin] = useState(false)
  const [focusedExam, setFocusedExam] = useState(false)

  const [selectedType, setSelectedType] = useState({ id: 1, title: 'همه' })
  const [selectedPrice, setSelectedPrice] = useState({ id: 0, title: 'همه' })
  const [selectedDifficulty, setSelectedDifficulty] = useState({ id: 0, title: 'همه' })
  const [selectedDesigner, setSelectedDesigner] = useState({ id: 0, title: 'همه' })

  const [routes, setRoutes] = useState([])
  const [folders, setFolders] = useState([])
  const [exams, setExams] = useState([])
  const [designers, setDesigners] = useState([])

  function getGroups() {
    apiCall({
      url: '/adminPanel/generalGroups',
      params: { user: true, type_id: 2, sub_to_id: routes.length > 0 ? routes[routes.length - 1].id : '' }
    }).then(res => {
      if (res && res.data) {
        setFolders(res.data)
      }
    }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
  }

  function getExams() {
    setIsLoading(true)
    apiCall({
      url: '/newExams/examList',
      params: {
        group_id: routes.length > 0 ? routes[routes.length - 1].id : '', difficulty: selectedDifficulty.id || '',
        price: selectedPrice.id || '', user: true, designer_id: selectedDesigner.id || undefined
      }
    }).then(res => {
      setIsLoading(false)
      if (res && res.data) {
        setExams(res.data)
      }
    }).catch(err => { toast.error('مشکل در سیستم'); setIsLoading(false) })
  }

  function getDesigner() {
    setIsLoading(true)
    apiCall({
      url: '/newExams/examDesigner',
    }).then(res => {
      const temp = [{ id: 0, title: 'همه' }]
      res.data.data.map((item, index) => temp.push({ ...item, title: item.name }))
      setDesigners(temp)
    }).catch(err => toast.error('مشکل در سیستم')).finally(() => setIsLoading(false))
  }


  useEffect(() => {
    validateToken()
    getDesigner()
  }, [])

  useEffect(() => getGroups(), [routes])
  useEffect(() => getExams(), [routes, selectedDifficulty, selectedPrice, selectedDesigner])

  return (
    <div>
      <h3 className="m-0 text-shadow font-16 pr-16">آزمون ها</h3>
      <hr className="mb-0" />

      {/* routes */}
      <div className="routes px-32 pt-22 flexed align-c">
        <button className="bd-none bg-none pr-0"
          disabled={routes.length === 0}
          onClick={() => setRoutes(routes.slice(0, routes.length - 1))}>
          <img src={Back} alt="" className="icon-md blocked" />
        </button>
        <button className="bd-none bg-none iran-sans font-11 text-semi-disabled">آزمون ها</button>
        <span>›</span>
        {
          routes.map((route, i) => (
            <React.Fragment key={route.id}>
              <button className="bd-none bg-none iran-sans font-11 text-semi-disabled">{route.title}</button>
              {i < routes.length - 1 && <span>›</span>}
            </React.Fragment>
          ))
        }
      </div>

      {/* dropdowns */}
      <div className="p-32 pb-0 grid" style={{ gridTemplateColumns: '1fr 1fr 1fr 2fr', gridColumnGap: 32, gridRowGap: 20 }}>
        <DropDown name="قیمت" items={[{ id: 0, title: 'همه' }, { id: 1, title: 'رایگان' }, { id: 3, title: 'پولی صعودی' }, { id: 2, title: 'پولی نزولی' }]}
          onItemClick={item => setSelectedPrice(item)} selectedItem={selectedPrice} />

        <DropDown name="سطح" items={[{ id: 0, title: 'همه' }, { id: 1, title: 'آسان' }, { id: 2, title: 'متوسط' }, { id: 3, title: 'سخت' }]}
          onItemClick={item => setSelectedDifficulty(item)} selectedItem={selectedDifficulty} />

        <DropDown name="نوع" items={[{ id: 1, title: 'همه' }, { id: 2, title: 'ناتمام' }, { id: 3, title: 'خریداری شده' }]}
          onItemClick={item => setSelectedType(item)} selectedItem={selectedType} />

        <DropDown name="طراح" items={designers}
          onItemClick={item => setSelectedDesigner(item)} selectedItem={selectedDesigner} />

      </div>

      {/* folders */}
      {selectedType.id == 1 && folders.length > 0 && <div className="grid p-32 pb-0" style={{ gridTemplateColumns: 'repeat(2, 1fr)', gridGap: 32 }}>
        {
          folders.map((folder) => (
            <GroupFolderItem key={folder.id} title={folder.title} icon={Folder}
              onClick={() => setRoutes([...routes, folder])} secondaryTitle={folder.count} />
          ))
        }
      </div>}

      {/* exams */}
      <div className="grid p-32 pb-0" style={{ gridTemplateColumns: 'repeat(2, 1fr)', gridGap: 32 }}>
        {[1, 3].indexOf(selectedType.id) > -1 &&
          exams[selectedType.id === 1 ? 'all' : 'bought_exams']?.map(exam => (
            <GroupFolderItem key={exam.id} title={`کد ${exam.id} - ${exam.title}`} icon={Exam}
              onClick={() => setFocusedExam(exam)} className={exam.has_bought ? "cursor-default" : ""}
              secondaryTitle={
                <div className="flexed fl-c fdir-col text-center" style={{ minWidth: 60 }}>
                  {exam.has_bought ? <span className="font-10">خریداری<br />شده</span> : exam.price > 0 ?
                    <><span className="font-11">{exam.price}</span><span className="font-10">تومان</span></> :
                    <span className="font-10">رایگان</span>}
                </div>
              } />
          ))
        }
        {selectedType.id === 2 && (
          exams.active.length > 0 ?
            exams.active?.map(t => {
              let { exam } = t
              return (
                <Link to={'/exam/list/' + t.id} className="folder-item p-0 bg-none bd-none iran-sans" key={exam.id}>
                  <GroupFolderItem className="w-100" key={exam.id} title={`کد ${exam.id} - ${exam.title}`} icon={Exam}
                    secondaryTitle={
                      <div className="flexed fl-c fdir-col text-center" style={{ minWidth: 60 }}>
                        {exam.price > 0 ?
                          <><span className="font-11">{exam.price}</span><span className="font-10">تومان</span></> :
                          <span className="font-10">رایگان</span>}
                      </div>
                    } />
                </Link>
              )
            }) :
            <div className="py-8 px-16">
              <span>آزمون ناتمامی موجود نیست</span>
            </div>)
        }
      </div>

      <PreJoinModal show={Boolean(focusedExam.id)} toggleShow={setFocusedExam} exam={focusedExam} full setIsLoading={setIsLoading} />
      <Loading full show={isLoading} />
    </div>
  )
}
